import { styled } from '@linaria/react';
import { NoStyleButton } from '../helpers/NoStyleButton';
export const FooterLink = /*#__PURE__*/styled('a')({
  name: "FooterLink",
  class: "fyv0vzz",
  propsAsIs: false
});
const _exp5 = /*#__PURE__*/() => NoStyleButton;
export const FooterLinkButton = /*#__PURE__*/styled(_exp5())({
  name: "FooterLinkButton",
  class: "fgsv0m8",
  propsAsIs: true
});

require("./FooterLinkButton.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FooterLinkButton.tsx");